import { battleSeenKey, createSeenList } from './seenList';

/**
 * Battle segments whose win popup (the closing pane) this player has already been shown.
 *
 * core keeps sending `closing` until the player claims or the claim window ends, and records nothing
 * about it being shown, so auto-open-once is the client remembering, per device — the same way the
 * opening pane's show-once is (see `openingSeen`). The widget still opens an unclaimed popup any time.
 */
const closings = createSeenList('slot-battle-closings-seen');

export const closingSeenKey = battleSeenKey;

export const readSeenClosings = closings.read;

/** Records the key and returns the updated list, newest first. */
export const markClosingSeen = closings.mark;
